import type { NodeProps } from '@xyflow/react';
import type { CanvasNodeData } from '@/hooks/useProcessCanvas';
import { BaseNode } from './BaseNode';

const SUB_TYPE_LABELS: Record<string, string> = {
  RULE: 'Rule',
  DECISION: 'Decision',
  RISK: 'Risk',
  WORKAROUND: 'Workaround',
  KPI: 'KPI',
  BUSINESS_OBJECT: 'Object',
};

export function InsightNode({ id, data }: NodeProps) {
  const d = data as unknown as CanvasNodeData;
  const subType = d.subType ? SUB_TYPE_LABELS[d.subType] ?? d.subType : undefined;

  return (
    <BaseNode
      nodeId={id}
      label={d.label}
      description={d.description}
      sourceType={d.sourceType}
      canvasNodeType="insight"
      edgeCount={d.edgeCount}
      subType={subType}
      staged={d.staged}
      contextCount={d.additionalContext?.length ?? 0}
    />
  );
}
